import { api } from "../../config/axios";
import IResponseBody from "../../interfaces/response-body";
import { environments } from "../../config/environments";
import { IRequestUserTO, IResponseUserTO, IUserCreate } from "../../models/user";
import {IPage, IPageable} from "../../models/pagination";

export const createUser = async (
  user: IUserCreate
): Promise<IResponseUserTO[] | undefined> => {
  const response = await api.post<IResponseBody<IResponseUserTO[]>>(
    environments.url_user_create,
    user
  );
  return response.data.data;
};

export const updateUser = async (
  user: IResponseUserTO
): Promise<IResponseUserTO[] | undefined> => {
  const response = await api.put<IResponseBody<IResponseUserTO[]>>(
    environments.url_user_create + `/${user.id}`,
    user
  );
  return response.data.data;
};

export const getAllUsers = async (pageable: IPageable, props?: IRequestUserTO): Promise<IPage<IResponseUserTO> | undefined> => {
  const response = await api.get<IResponseBody<IPage<IResponseUserTO>>>(
    environments.url_user_create,{
      params: {
        page: pageable.page,
        size: pageable.size,
        sort: pageable.sort,
        name: props?.name,
        email: props?.email,
        username: props?.username,
        active: props?.status,
        ...props
      }
    }
  );
  return response.data.data;
};

export const UserService = {
  createUser,
  getAllUsers,
  updateUser,
};
